import { initViewerModule } from './viewer';
import { initGallery } from './gallery';
import { initImageScopeLauncher } from './image-scope';

export function initModules (app) {
  initImageScopeLauncher(app);
  initViewerModule(app);
  initGallery(app);
}
